module.exports = __webpack_public_path__ + "static/media/scrum.ae609dab.png";